import type { AppParamsChangedAction } from '../types/actions'

import { actionFactory } from './factory'

export const appParamsChanged = actionFactory<AppParamsChangedAction>(
  (state, { appParams }) => {
    state.appParams = appParams
  },
  'appParamsChanged'
)
